import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { Table, Modal , Tag} from "antd";
import { DatePicker } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import SearchBar from "../../../utils/Searchbar";
import CphActions from "../../../redux/customer_payment_history/actions";
import moment from "moment";
import { maskEmail } from "../../../utils/maskMobileNum";
const columns = [
  {
    title: "#",
    dataIndex: "key",
    key: "key",
    width: 100, // Fixed width
  },
  {
    title: "Mobile Number",
    dataIndex: "mob_no",
    width: 100, // Fixed width
  },
  {
    title: "Ref Id",
    dataIndex: "refId",
    width: 100, // Fixed width
  },
  {
    title: "Transaction Id",
    dataIndex: "transId",
    width: 100, // Fixed width
  },
{
    title: "Email Id",
    dataIndex: "emailId",
    width: 100, // Fixed width
  },
  {
    title: "Amount",
    dataIndex: "amount",
    width: 100, // Fixed width
  },
  {
    title: "Status",
    dataIndex: "status",
    width: 100, // Fixed width
  },
  {
    title: "Payment Mode",
    dataIndex: "paymentMode",
    width: 100, // Fixed width
  },
  {
    title: "Created At",
    dataIndex: "createdAt",
    width: 100, // Fixed width
  },
];
const { getCphDetailData } = CphActions;
const CustomerModal = ({ fromTitle, open, handleCancel,transactionHistory,agentId }) => {
  const dispatch = useDispatch();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const { cphDetailResponseData,loading,totalData } = useSelector(
    (state) => state.chpReducer
  );
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
  });
  const data =
    cphDetailResponseData &&
    cphDetailResponseData?.length > 0 &&
    cphDetailResponseData?.map((items, index) => {
      return {
        key: (tableParams.current - 1) * tableParams.pageSize + index + 1,
        mob_no: items.mobileNumber,
        refId: items.refId,
        paymentMode: items.paymentMode,
        amount: items.amount,
        status: (
          <Tag
            color={
              items?.status?.toLowerCase() === "successful"
                ? "green"
                : items?.status?.toLowerCase() === "pending" ||
                  items?.cuResponse?.toLowerCase() === "pending"
                ? "orange"
                : "red"
            }
          >
            {items.status}
          </Tag>
        ),
        transId: items.transactionId,
        emailId: maskEmail(items.email) || <Tag>{""} </Tag>,
        createdAt: (
          <>
            <p className="m-0 p-0">
              {moment(items?.createdAt).format("DD MMMM YYYY")}
            </p>
            <p className="m-0 p-0">
              {moment(items?.createdAt).format("hh:mm:ss A")}
            </p>
          </>
        ),
      };
    });
  const handlePageChange = async (pagination, sofilters, rter) => {
    const { current, pageSize } = pagination;
    setTableParams({ current, pageSize });
    if (fromDate && toDate) {
      dispatch(getCphDetailData(current, pageSize, "", fromDate?.format('YYYY-MM-DD'), toDate?.format('YYYY-MM-DD')));
  } else {
      dispatch(getCphDetailData(current, pageSize));
  }
}
  const handleFromDateChange = (date) => {
    setFromDate(date);
  };

  const disabledToDate = (current) => {
    return (
      (fromDate &&
        current &&
        (current < fromDate.startOf("day") ||
          current > moment().startOf("day"))) ||
      (current && current > moment().startOf("day"))
    );
  };
  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };
  const handleToDateChange = (date) => {
    setToDate(date);
    if (date) {
      const fromSendDate = fromDate?.format("YYYY-MM-DD");
      const toDate = date?.format("YYYY-MM-DD");
      dispatch(getCphDetailData(transactionHistory?.mobileNumber, 1,10,"", fromSendDate, toDate));
    }else{
      dispatch(getCphDetailData(transactionHistory?.mobileNumber, 1,10,"", "", ""));

    }
  };
  let timeoutId;
  const handleFilterChange = (e) => {
    e.preventDefault();
    const value = e.target.value;
    if (timeoutId) {
      clearTimeout(timeoutId); // Clear the previous timeout if it exists
    }
    timeoutId = setTimeout(() => {
      dispatch(getCphDetailData(transactionHistory?.mobileNumber, 1,10,value));
    }, 1000);
  };

  return (
    <Modal
      title={fromTitle}
      open={open}
      onCancel={handleCancel}
      width={1000}
      maskClosable={false}
      footer={null}
    >
      <div className="mainContain" >
        <div className="datesearchFi">
          <div className="">
            <SearchBar onChange={handleFilterChange}  />
          </div>
          <div className="inputfatef">
            <div>
              <DatePicker
                value={fromDate}
                style={{ width: "100%", border: "none",backgroundColor: '#f0f0f0' }}
                onChange={handleFromDateChange}
                disabledDate={disabledDate}
                format="DD-MM-YYYY"
                placeholder="From (DD-MM-YYYY)" // Placeholder added here
                suffixIcon={
                  <CalendarOutlined
                    style={{ color: "#d9d3d3" }}
                  />
                }
              />
            </div>
            <div>
              <DatePicker
                value={toDate}
                style={{ width: "100%", border: "none",backgroundColor: '#f0f0f0' }}
                onChange={handleToDateChange}
                disabledDate={disabledToDate}
                format="DD-MM-YYYY"
                placeholder="To (DD-MM-YYYY)" // Placeholder added here
                suffixIcon={
                  <CalendarOutlined
                    style={{ color: "#d9d3d3" }}
                  />
                }
              />
            </div>
          </div>
        </div>
        <div className="mt-3">
          <Table
            columns={columns}
            dataSource={data}
            scroll={{ x: 600 }}
            pagination={{
              total: {totalData}, // totalData,
              current: tableParams.current,
              pageSize: tableParams.pageSize,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "50"],
            }}
            onChange={handlePageChange}
          />
        </div>
      </div>
    </Modal>
  );
};

CustomerModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleCancel: PropTypes.func.isRequired,
};

export default CustomerModal;
